/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module } from '@msdyn365-commerce-modules/utilities';

import * as React from 'react';
import { ICittaJournalPostsViewProps } from './citta-journal-posts';

export default (props: ICittaJournalPostsViewProps) => {

    return (
        <Module {...props.JournalsWrapper} > 
            {props.categories}
            {props.search}
           
            <div className="grid-row">
                {props.journals}
            </div>
            {props.loadMore}
        </Module>
    );
};
